import React from 'react'

export default function TypeUnique({
    questiondata,
    setQuestionData,
    updateData,
    data,
    index,
}: any): JSX.Element {
    const { data_unique } = questiondata

    const addNewAlternative = () => {
        function randomId(): string {
            const uint32 = window.crypto.getRandomValues(new Uint32Array(1))[0]
            return uint32.toString(16)
        }
        const alternative = { _id: randomId(), correct: false, value: '' }
        setQuestionData({
            ...questiondata,
            data_unique: [...questiondata.data_unique, alternative],
        })
        if (updateData) {
            updateData(
                { ...data, alternatives: [...questiondata.data_unique, alternative] },
                index,
            )
        }
    }

    const onChangeInputs = (id: string, e: any) => {
        const alternatives = data_unique.map((opt: any) => {
            if (opt._id === id) {
                opt.value = e.target.value
                return opt
            } else {
                return opt
            }
        })

        setQuestionData({
            ...questiondata,
            data_unique: alternatives,
        })
        if (updateData) {
            updateData({ ...data, alternatives: alternatives }, index)
        }
    }

    const onSetAnswer = (id: string) => {
        const alternatives = data_unique.map((opt: any) => {
            if (opt._id === id) {
                opt.correct = true
                return opt
            } else {
                opt.correct = false
                return opt
            }
        })

        setQuestionData({
            ...questiondata,
            data_unique: alternatives,
        })
        if (updateData) {
            updateData({ ...data, alternatives: alternatives }, index)
        }
    }

    const onRemoveAlternative = (id: string) => {
        setQuestionData({
            ...questiondata,
            data_unique: data_unique.filter((opt: any) => opt._id !== id),
        })
        if (updateData) {
            updateData(
                {
                    ...data,
                    alternatives: data.alternatives.filter((opt: any) => opt._id !== id),
                },
                index,
            )
        }
    }

    return (
        <div className="alternatives_content">
            {data_unique.length ? (
                data_unique.map((opt: any, key: number) => {
                    const { _id, value, correct } = opt

                    return (
                        <div key={key} className="alternatives_item">
                            <div className="inputs">
                                <input
                                    className="input_question"
                                    placeholder="Escribe aqui..."
                                    autoFocus={true}
                                    onChange={(e) => onChangeInputs(_id, e)}
                                    value={value}
                                    required
                                />
                                <button
                                    type="button"
                                    onClick={() => onRemoveAlternative(_id)}
                                >
                                    <span className="fa fa-trash"></span>
                                </button>
                            </div>
                            <div className="choose" onClick={() => onSetAnswer(_id)}>
                                <input
                                    id={_id}
                                    className={`${correct}`}
                                    value={correct}
                                    type="radio"
                                    // name="group_name"
                                    checked={correct === true}
                                    required
                                />
                                <span>Marcar como respuesta correcta</span>
                            </div>
                        </div>
                    )
                })
            ) : (
                <div className="alternatives_message">
                    <h4>Aún no hay alternativas</h4>
                </div>
            )}

            <div className="alternatives_buttons">
                <button onClick={addNewAlternative}>
                    <span className="fas fa-plus"></span> Agregar Alternativa
                </button>
            </div>
        </div>
    )
}
